import clsx from 'clsx';

import { TSvgComponentProps } from '../../types';

/**
 * Custom Svg Circle icon for loader. it draw a circle radius of 45
 */
function LoadingIcon(props: TSvgComponentProps) {
  return (
    <svg
      height="1em"
      viewBox="0 0 100 100"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={50} cy={50} r={45} />
    </svg>
  );
}

/**
 * This is a Circular Progress indicator for loading.
 * It will add Styles and animations for `LoaderIcon` it will give a circular
 * animation with 2s delay.
 */
export function CameraProgressLoader({
  className,
  ...rest
}: TSvgComponentProps) {
  return (
    <LoadingIcon
      {...rest}
      className={clsx('deprecated-camera-progress-loader', className)}
    />
  );
}
